import { c as _c } from "react/compiler-runtime";
import Cookies from 'js-cookie';
import { useState, ViewTransition } from 'react';
import { getENV, type SitePreviewData, useSitePreviewData } from '@libs/common-next';
import { Configuration } from './configuration';
import { Entries } from './entries';
import css from './preview.module.scss';
export function Preview() {
  const $ = _c(21);
  const sitePreviewData = useSitePreviewData();
  let t0;
  if ($[0] !== sitePreviewData) {
    t0 = () => sitePreviewData ?? {};
    $[0] = sitePreviewData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [state, setState] = useState(t0);
  const [dirty, setDirty] = useState(false);
  if (!getENV("NEXT_PUBLIC_SITE_PREVIEW")) {
    return null;
  }
  const removePreviewParam = _temp;
  let t1;
  if ($[2] !== state) {
    t1 = (key, value) => {
      const newState = {
        ...state,
        [key]: value
      };
      setState(newState);
      Cookies.set("x-petm-preview", JSON.stringify(newState), {
        expires: 0.041666666666666664
      });
      removePreviewParam();
      setDirty(true);
    };
    $[2] = state;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleChange = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      Cookies.remove("x-petm-preview");
      removePreviewParam();
      globalThis.location.reload();
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleLeave = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      removePreviewParam();
      globalThis.location.reload();
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleRefresh = t3;
  let t4;
  if ($[6] !== handleChange || $[7] !== state) {
    t4 = <div className={css.scrollArea}><Configuration state={state} onChange={handleChange} /></div>;
    $[6] = handleChange;
    $[7] = state;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <button className={`${css.btn} ${css.buttonLeave}`} onClick={handleLeave}><span>⊘</span>Leave Preview</button>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== dirty) {
    t6 = dirty && <span className={css.refreshHint}>Refresh to see changes</span>;
    $[10] = dirty;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <button className={`${css.btn} ${css.buttonRefresh}`} onClick={handleRefresh}><span>⊙</span>Refresh</button>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <div className={css.footer}>{t5}<div className={css.footerActions}>{t6}{t7}</div></div>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = <div className={css.section}>{t4}{t8}</div>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Entries />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t9) {
    t11 = <ViewTransition name="container"><div className={css.wrapper}>{t9}{t10}</div></ViewTransition>;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp() {
  const url = new URL(globalThis.location.href);
  url.searchParams.delete("_preview");
  globalThis.history.replaceState(null, "", url);
}